// import { parse } from '@fortawesome/fontawesome-svg-core';
import React, { useEffect, useState } from 'react'
import { Container, Col, Row, Button, Form, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IPUrl } from "../commons/IPAddress";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiUrl } from "../commons/inFormTypes";
import axios from 'axios';
import Loaders from '../components/Loaders';

function FinalInfo() {
    const [snip, setSnip] = useState(false);
    const name = localStorage.getItem("users_name");
    const mstr = JSON.parse(localStorage.getItem("Master"));
    const lstarray = JSON.parse(localStorage.getItem("Lstarray"));
    const userToken = localStorage.getItem("user_token");
    const CodeMeliUser = localStorage.getItem("CodeMeli");
    const navigate = useNavigate()


    useEffect(() => {
        if (userToken == null) {
            navigate("/");
        } else { }
    }
        , [])

    const submitHandler = () => {

        const axios = require("axios");
        setSnip(true);
        axios
            .post(apiUrl + "Insert_StationOrders", {
                ldetails: localStorage.getItem("Lstarray"),
                lmaster: localStorage.getItem("Master"),
                TokenId: userToken,
                Code_Meli: CodeMeliUser
            })

            .then((res) => {
                setSnip(false);
                if (res.data.result === "true") {
                    navigate("../dashboard");
                    localStorage.removeItem("Master");
                    localStorage.removeItem("Lstarray");
                    localStorage.removeItem("CodeMeli");
                    localStorage.removeItem("users_name");

                    toast.success(res.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {

                }
            })
            .catch(function (error) {
                if (error.response) {
                    toast.error(error.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            });
    }




    return (
        <div>
            {lstarray !== null ?
                <Container>
                    <Row className="justify-content-center mb-3">
                        <Col xs={11} lg={9} className="mt-3">
                            <Row className="justify-content-center gy-3 gx-5">
                                <Col xs={12}>
                                    <div className="d-flex rgc-title">
                                        <div className="rgc-title-point"></div>
                                        <h4>اطلاعات <span>سفارش دهنده</span></h4>
                                    </div>
                                </Col>


                                <Col xs={12} className="rgc-driver-txt">
                                    <Row className="justify-content-around  rgc-station-time">
                                        <Col xs={12} md={6} className="rgc-order-span">
                                            <span>نام و نام خانوادگی:</span>
                                            <span>{name}</span>
                                        </Col>

                                        <Col xs={12} md={6} className="rgc-order-span">
                                            <span>کد ملی:</span>
                                            <span>{CodeMeliUser}</span>
                                        </Col>

                                    </Row>
                                </Col>

                                <div className={mstr[0].deliveryId === 5 ? "d-block" : "d-none"}>
                                    <Col xs={12}>
                                        <div className="d-flex rgc-title">
                                            <div className="rgc-title-point"></div>
                                            <h4>اطلاعات <span>ایستگاه </span></h4>
                                        </div>
                                    </Col>

                                    <Col xs={12} className="rgc-driver-txt">
                                        <Row className="justify-content-around  rgc-station-time">
                                            <Col xs={12} className="rgc-order-span">
                                                <span> عنوان:</span>
                                                <span>{mstr[0].stationTitle}</span>
                                            </Col>

                                            <Col xs={12} className="rgc-order-span">
                                                <span>آدرس:</span>
                                                <span>{mstr[0].address} {mstr[0].stationAddress}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </div>


                                <Col xs={12}>
                                    <div className="d-flex rgc-title">
                                        <div className="rgc-title-point"></div>
                                        <h4>اطلاعات <span>سفارش </span></h4>
                                    </div>
                                </Col>

                                <Col xs={12} className="rgc-driver-txt rgc-station-time">
                                    <Row className="justify-content-around">

                                        <Col xs={12} md={6}>
                                            {lstarray.map((item, index) => {
                                                return (
                                                    <Row key={index} className="justify-content-around  rgc-station-time">

                                                        <Col xs={2}>
                                                            <Image src={IPUrl + item.icon} alt="" className="rgc-image" />
                                                        </Col>

                                                        <Col xs={10}>
                                                            <span>{item.name}</span>
                                                        </Col>

                                                        <Col xs={6} className="rgc-order-span text-center">
                                                            <span>وزن:</span>
                                                            <span>{item.count}{item.titleWeight} </span>
                                                        </Col>

                                                        <Col xs={6} className="rgc-order-span text-center">
                                                            <span>مبلغ:</span>
                                                            <span>{Intl.NumberFormat('en-US').format(item.Sum)}</span>
                                                        </Col>

                                                    </Row>
                                                )
                                            }
                                            )}

                                        </Col>


                                        <Col xs={9} className="rgc-driver-txt text-center my-2">
                                            <hr />
                                            <div className="d-flex flex-column justify-content-center">
                                                <div className="rgc-order-span">
                                                    <span>مجموع مبالغ:</span>
                                                    <span>{Intl.NumberFormat('en-US').format(mstr[0].coint)}</span>
                                                </div>

                                                <div className="rgc-order-span">
                                                    <span>مجموع وزن:</span>
                                                    <span>{mstr[0].weight}</span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>


                                <Col xs={5} md={4} className="text-center pt-4">
                                    <Button onClick={submitHandler} className="rgc-order-btns rgc-order-btn-sub" >
                                        <Loaders loads={snip} />
                                        ثبت نهایی
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                : navigate("../dashboard")
            }
        </div>
    )
}

export default FinalInfo